import React from "react";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import { inject, observer } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STGrid, STHomeWrapper, STPageHeader } from "./styles";
import { IManagementStore } from "@src/Stores/Management/types";
import ComponentApps from "@src/Components/Common/ComponentApps/ComponentApps";

interface IProps {
    auth?: IAuthStore;
    management?: IManagementStore;
}

@inject("auth", "management")
@observer
export default class Home extends React.Component<IProps> {
    
    async componentDidMount() {
        document.title = Values.getLocalizationValue("home");
    }

    render() {
        return (
            <Grid container justify="center">
                <Grid item xs={12}>
                    <STPageHeader>{Values.getLocalizationValue("home")}</STPageHeader>
                </Grid>
                <Grid item>
                    <STHomeWrapper>
                        <STGrid container justify="center" alignItems="center">
                            <ComponentApps sameApp={true} />
                        </STGrid>
                    </STHomeWrapper>
                </Grid>
            </Grid>
        );
    }
}
